import classNames from 'classnames'
import React from 'react'

import { CircledInitial, CircledText } from '../../atoms/CircledInitial'
import { Tooltip } from '../../atoms/Tooltip'
import { PASStatus } from '../../domain/PAS.domain'

export const PASStatusView: React.FC<{
    status: PASStatus
    short?: boolean
    className?: string
    onClick?: () => void
}> = props => {
    const classMap = {
        [PASStatus.NotStarted]: 'border-red-500 text-atamblue-700',
        // [PASStatus.Pending]: 'border-purple-500 text-atamblue-700',
        [PASStatus.AwaitingData]: 'border-orange-500 text-atamblue-700',
        [PASStatus.AwaitingOILData]: 'border-atamblue-500 text-atamblue-700',
        [PASStatus.UnderReview]: 'border-blue-500 text-atamblue-700',
        [PASStatus.Completed]: 'border-green-500 text-atamblue-700',
        [PASStatus.NotApplicable]: 'border-gray-500 text-atamblue-700',
    }
    const shortTextMap = {
        [PASStatus.NotStarted]: 'NS',
        // [PASStatus.Pending]: 'P',
        [PASStatus.AwaitingData]: 'AD',
        [PASStatus.AwaitingOILData]: 'AOD',
        [PASStatus.UnderReview]: 'UR',
        [PASStatus.Completed]: 'C',
        [PASStatus.NotApplicable]: 'NA',
    }

    const longTextMap = {
        [PASStatus.NotStarted]: 'Not Started',
        // [PASStatus.Pending]: 'Pending',
        [PASStatus.AwaitingData]: 'Awaiting Data',
        [PASStatus.AwaitingOILData]: 'Awaiting OIL Data',
        [PASStatus.UnderReview]: 'Under Review',
        [PASStatus.Completed]: 'Completed',
        [PASStatus.NotApplicable]: 'Not Applicable',
    }
    const short = props.short ?? false
    return short ? (
        <Tooltip text={longTextMap[props.status]}>
            <CircledInitial
                content={shortTextMap[props.status]}
                className={classNames(classMap[props.status], props.className)}
                onClick={props.onClick}
            />
        </Tooltip>
    ) : (
        <CircledText
            className={classNames(classMap[props.status], props.className)}
            onClick={props.onClick}
        >
            {longTextMap[props.status]}
        </CircledText>
    )
}
